"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebounced = void 0;
var react_1 = require("react");
function useDebounced(value, time) {
    var timer = (0, react_1.useRef)();
    var _a = (0, react_1.useState)(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    (0, react_1.useEffect)(function () {
        if (debouncedValue !== value) {
            if (typeof timer.current !== 'undefined') {
                clearTimeout(timer.current);
            }
            timer.current = setTimeout(function () {
                setDebouncedValue(value);
            }, time);
        }
        return function () {
            if (typeof timer.current !== 'undefined') {
                clearTimeout(timer.current);
            }
        };
    }, [value, debouncedValue, time]);
    return debouncedValue;
}
exports.useDebounced = useDebounced;
